import { LinkSection } from "components/base/LinkSection";
import SinglePreviewCard from "components/campaignStreamline/SinglePreviewCard";
import { EarningRuleRewardType } from "config/CustomEnums";
import { STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY } from "config/PageAnchorConfig/StampCampaignAnchorConfig";
import React from "react";
import { connect } from "react-redux";
import { removeDuplicatesByFieldFromArray } from "utils";

const getStampCampaiganLinkedCouponrewards = (campaignData) => {
  if (!campaignData?.stampRewards || !campaignData?.stampRewards?.length > 0) {
    return [];
  }
  const result = campaignData?.stampRewards?.filter(
    reward => reward?.rewardType === EarningRuleRewardType.coupons && reward?.linkedCoupon
  )?.map(reward => reward.linkedCoupon)
    
  return removeDuplicatesByFieldFromArray(result, "pk");
}
const StampCampaignDisplay = ({campaign}) => {
  const couponRewards = getStampCampaiganLinkedCouponrewards(campaign)
  return <ul>
    {couponRewards?.map((item) => (
      <li>
        {`[ID: ${item.pk}] ${item.name}`}
        <LinkSection
          link={`/coupons/${item.pk}/`}
          linkText={"View detail"}
          openNewTab
        />
      </li>
    ))}
  </ul>
}

const getStampCampaignRewardCard = (campaignData) => [
  {
    step: 2,
    anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
    sectionContent: [
      {
        title: "Link to coupon",
        errorField: "couponTypeRewardError",
        customRender: <StampCampaignDisplay campaign={campaignData} />,
        anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionContent.reward_section_key,
      },
      {
        isMandatory: true,
        errorField: "stampRewardError",
        title: "Total stamp quantity",
        field: "totalStampQuantity",
        anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionContent.reward_section_key,
      },
    ]
  },
  {
    step: 2,
    sectionTitle: "EXECUTION PROIORITY FOR GLOBAL LIMIT",
    anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        title: "Execution priority",
        field: "executionPriority",
        anchorKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionContent.execution_priority_input_key,
      },
    ]
  },
]

const StampCampaignPreviewRewardCard = ({
  errors,
  campaignData,
  language,
  hideEditButton = false,
}) => {
  return (
    <SinglePreviewCard
      language={language}
      data={campaignData}
      cardInfo={getStampCampaignRewardCard(campaignData)}
      errors={errors}
      hideEditButton={hideEditButton}
    />)
}

const mapPropsToState = (state) => ({
  errors: state.createCampaign.errorFields,
});

export default connect(mapPropsToState)(StampCampaignPreviewRewardCard);